import React from "react";
import styled, { css } from "styled-components";
import { toast } from "react-toastify";

import { CheckboxStyled } from "src/library/components/Forms";
import { Text } from "src/library/components/Text";
import useTerminology from "src/core/shared/hooks/useTerminology";

import { OrderType } from "../../api/orders.api";

export interface SelectOrderTypesProps {
  selectedOrderTypes: OrderType[];
  onChange: (value: string[]) => void;
}

const SelectOrderTypes: React.FunctionComponent<SelectOrderTypesProps> = ({ selectedOrderTypes, onChange }) => {
  const terminology = useTerminology();

  // handles the form events to set the selected order types
  const handleOnChange = (orderType: OrderType, checked: boolean) => {
    if (checked) {
      // ensure included in order types
      if (!selectedOrderTypes.includes(orderType)) {
        onChange([ ...selectedOrderTypes, orderType ]);
      }
    } else {
      // ensure not included in order types
      if (selectedOrderTypes.includes(orderType)) {
        onChange(selectedOrderTypes.filter(v => v !== orderType));
      }
    }
  };

  if (!terminology) {
    return null;
  }

  return (
    <StyledWrapper>
      <div className="order-type">
        <CheckboxStyled
          checked={selectedOrderTypes.includes("adhoc")}
          onChange={e => handleOnChange("adhoc", e.target.checked)}
        />

        <Text>
          Adhoc
        </Text>
      </div>

      <div className="order-type">
        <CheckboxStyled
          checked={selectedOrderTypes.includes("bulk")}
          onChange={e => handleOnChange("bulk", e.target.checked)}
        />

        <Text>
          Bulk
        </Text>
      </div>
    </StyledWrapper>
  );
};

const StyledWrapper = styled.div`
  ${({ theme }) => css`
    .order-type {
      display: flex;
      align-items: center;
      margin-bottom: ${theme.spacing.margins.sm};

      input {
        margin-right: ${theme.spacing.margins.md};
      }
    }
  `}
`;

export default SelectOrderTypes;